function i({
  collapseOnMobile: n,
  collapseOnTablet: d,
  reverseOnCollapse: u
}) {
  return u ? {
    firstChildStyles: {
      paddingLeft: [
        n ? null : "none",
        d ? null : "none",
        "none"
      ],
      paddingTop: [
        n ? null : "none",
        d ? null : "none",
        "none"
      ]
    },
    lastChildStyles: {
      paddingLeft: [
        n ? "none" : null,
        d ? "none" : null,
        null
      ],
      paddingTop: [
        n ? "none" : null,
        d ? "none" : null,
        null
      ]
    }
  } : {
    firstChildStyles: {
      paddingLeft: "none",
      paddingTop: "none"
    }
  };
}
export {
  i as removePaddingFromVisuallyFirst
};
